<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li>号码认证</li>
                <li>号码认证管理</li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle">
                <span>号码认证管理</span>
            </div>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;margin-bottom: 15px;" @click="checkselect('')">全部</el-button>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;margin-bottom: 15px;" @click="checkselect('1')">通过</el-button>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;margin-bottom: 15px;" @click="checkselect('0')">待审核</el-button>
            <el-button type="primary" class="top_button" style="letter-spacing: 2px;margin-bottom: 15px;" @click="checkselect('-1')">未通过</el-button>
            <!-- <el-button type="danger" class="top_button" style="letter-spacing: 2px;float:right;" @click="deletechoose()">批量删除</el-button>
            <el-button type="warning" class="top_button" style="letter-spacing: 2px;float:right;" name="all" id="all" @click="selectall()">全选</el-button> -->
            <div id="usual1" class="usual"> 
                <div id="tab1" class="tabson">                
                    <table class="tablelist">
                        <thead>
                            <tr>								
                                <th style="width:10%">门牌号</th>
                                <th style="width:10%">受理文件</th>
                                <th style="width:10%">营业执照</th>
                                <th style="width:10%">申请时间</th>
                                <th style="width: 10%">原因</th>
                                <th style="width:10%">状态</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list" :class="{odd:index%2!=0}">
                                <td style="width:10%">
                                    {{item.account}}
                                </td>
                                <td style="width:10%">
                                    {{item.txtPath}}
                                </td>
                                <td style="width:10%">
                                    {{item.companyPath}}
                                </td>
                                <td style="width:10%">
                                    {{item.createTime.substring(0, 19)}}
                                </td>
                                <td style="width:10%">
                                    {{item.demo}}
                                </td>
                                <td style="width:10%">
                                    <template v-if="item.status == 0">
                                        待审核
                                    </template>
                                    <template v-else-if="item.status == 1">
                                        审核通过
                                    </template>
                                    <template v-else-if="item.status == -1">
                                        审核未通过
                                    </template>
                                </td>
                            </tr>     
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="pagin" style="float:right;margin-bottom:15px;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[pageSize]"
                :page-size="50"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </div>

        <!-- 查询等待 -->
        <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
            top: 0; left: 0;display: block;" v-show="loadingShow"></div>
        <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
            -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
            <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
            <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
        </div>

    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'

export default {
    data() {
        return{
            list: [],
            status: '',
            pageIndex: 1,
            pageSize: 50,
            totalCount: 0,
            loadingShow: true,
        }
    },
    components: {
        'v-cookie': cookie
    },
    mounted() {
        if(this.$route.query.status == undefined)
        {
            this.outlogin();
        }
        else
        {
            this.status = this.$route.query.status;
            this.pageChange(1);
        }
    },
    methods: {
        outlogin() {
            delCookie('2officesessionid')
            alert("请求地址有误,请重新登录！");
            this.$router.push('/');
        },
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            var that = this;
            let param = {'status': this.status, 'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/authenticationnumber/authenticationnumbermanage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.list = res.data.authenticationNumberList
                    that.formata(that.list);
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    that.$alert(res.data.msg);
                    return false;
                }
            })
        },
        checkselect(status) {
            this.status = status;
            this.pageChange(1);
        },
        formata: function(data) {
            let result = [];
            if (data){
            data.map((item,index)=>{
                item.txtPath = item.txtPath.split("\\")[4];
                item.companyPath = item.companyPath.split("\\")[4];
                result.push(item);
            })
            }
            return result;
        },
    }
}

</script>


// WEBPACK FOOTER //
// src/components/authenticationnumber/authenticationnumbermanage.vue